/**
 * GomiMall - Influencer & Creator Dashboard Engine
 * Includes:
 * 1. Password-based registration & authentication
 * 2. Instant Creator access & 1-click customer upgrade
 * 3. Sub-Influencer recruitment & Squad Invite link sharing
 * 4. Sub-Influencer Network tracking (sales, orders, override commission)
 * 5. Detailed "Sold Products Breakdown" inspection modal
 * 6. Dynamic product catalog & custom URL link generation
 */

document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('gomi-influencer-app');
  if (!container) return;

  let influencerCode = container.dataset.influencerCode || localStorage.getItem('gomi_influencer_code') || '';
  const customerEmail = container.dataset.customerEmail || '';
  const customerId = container.dataset.customerId || '';
  const shopOrigin = window.location.origin;

  // Sync back to container dataset if retrieved from storage
  if (influencerCode && !container.dataset.influencerCode) {
    container.dataset.influencerCode = influencerCode;
  }

  // Cloudflare Workers Backend URL (configured for GomiMall)
  const BACKEND_URL = window.GOMI_INFLUENCER_BACKEND || 'https://gomimall-influencer-backend.ibrar9.workers.dev';

  /* ==========================================================================
     1. GUEST AUTH: TAB SWITCHING & URL HASHES
     ========================================================================== */
  const tabBtnReg = document.getElementById('tab-btn-register');
  const tabBtnLogin = document.getElementById('tab-btn-login');
  const paneReg = document.getElementById('inf-pane-register');
  const paneLogin = document.getElementById('inf-pane-login');
  const switchToLoginLinks = document.querySelectorAll('.inf-switch-to-login');
  const switchToRegLinks = document.querySelectorAll('.inf-switch-to-register');

  function showRegisterTab() {
    if (tabBtnReg && tabBtnLogin && paneReg && paneLogin) {
      tabBtnReg.classList.add('active');
      tabBtnLogin.classList.remove('active');
      paneReg.style.display = 'block';
      paneLogin.style.display = 'none';
    }
  }

  function showLoginTab() {
    if (tabBtnReg && tabBtnLogin && paneReg && paneLogin) {
      tabBtnLogin.classList.add('active');
      tabBtnReg.classList.remove('active');
      paneLogin.style.display = 'block';
      paneReg.style.display = 'none';
    }
  }

  if (tabBtnReg) tabBtnReg.addEventListener('click', showRegisterTab);
  if (tabBtnLogin) tabBtnLogin.addEventListener('click', showLoginTab);

  switchToLoginLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      showLoginTab();
    });
  });

  switchToRegLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      showRegisterTab();
    });
  });

  // Check URL Hash (#login or #register)
  if (window.location.hash === '#login') {
    showLoginTab();
  }

  /* ==========================================================================
     2. PASSWORD VISIBILITY TOGGLE (EYE ICON)
     ========================================================================== */
  const pwdToggles = document.querySelectorAll('.inf-pwd-toggle');
  pwdToggles.forEach(btn => {
    btn.addEventListener('click', function() {
      const inputId = btn.dataset.input;
      const input = document.getElementById(inputId);
      if (!input) return;

      if (input.type === 'password') {
        input.type = 'text';
        btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>`;
      } else {
        input.type = 'password';
        btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>`;
      }
    });
  });

  /* ==========================================================================
     3. SUB-INFLUENCER RECRUITMENT LINK DETECTION (?sub_ref=...)
     ========================================================================== */
  const urlParams = new URLSearchParams(window.location.search);
  const detectedSubRef = urlParams.get('sub_ref') || 
                          urlParams.get('parent_ref') || 
                          urlParams.get('invite_ref') || 
                          urlParams.get('ref') || 
                          localStorage.getItem('gomi_sub_ref') || 
                          getCookie('gomi_sub_ref') || '';

  const parentRefInput = document.getElementById('InfReg-parent-ref');
  const parentRefBadge = document.getElementById('inf-parent-ref-badge');
  const parentRefName = document.getElementById('inf-parent-ref-name');

  if (detectedSubRef && parentRefInput) {
    const cleanSubRef = detectedSubRef.trim().replace(/[^a-zA-Z0-9_-]/g, '');
    if (cleanSubRef) {
      parentRefInput.value = cleanSubRef;
      if (parentRefBadge && parentRefName) {
        parentRefName.textContent = '@' + cleanSubRef;
        parentRefBadge.style.display = 'block';
      }
    }
  }

  // Live link preview as user types preferred code
  const regCodeInput = document.getElementById('InfReg-code');
  const livePreviewText = document.getElementById('inf-live-preview-text');
  if (regCodeInput && livePreviewText) {
    regCodeInput.addEventListener('input', function() {
      const val = regCodeInput.value.trim().toLowerCase().replace(/[^a-z0-9_-]/g, '');
      livePreviewText.textContent = `${shopOrigin}/?ref=${val || 'yourname'}`;
    });
  }

  /* ==========================================================================
     4. REGISTRATION FORM VALIDATION & INSTANT BACKEND SYNC
     ========================================================================== */
  const regForm = document.getElementById('InfluencerRegistrationForm');
  const submitRegBtn = document.getElementById('inf-btn-submit-reg');

  if (regForm && submitRegBtn) {
    regForm.addEventListener('submit', function(e) {
      const pwd = document.getElementById('InfReg-password');
      const pwdConfirm = document.getElementById('InfReg-password-confirm');
      const email = document.getElementById('InfReg-email');
      const code = document.getElementById('InfReg-code');
      const phone = document.getElementById('InfReg-phone');
      const social = document.getElementById('InfReg-social');
      const firstName = document.getElementById('InfReg-first-name');
      const lastName = document.getElementById('InfReg-last-name');
      const parentRef = document.getElementById('InfReg-parent-ref');

      // Validation 1: Password match
      if (pwd && pwdConfirm && pwd.value !== pwdConfirm.value) {
        e.preventDefault();
        alert('Validation Error: Passwords do not match. Please re-enter both passwords.');
        pwdConfirm.focus();
        return false;
      }

      // Validation 2: Password minimum length
      if (pwd && pwd.value.length < 6) {
        e.preventDefault();
        alert('Validation Error: Password must be at least 6 characters long.');
        pwd.focus();
        return false;
      }

      // Validation 3: Creator Code pattern
      const codeClean = (code ? code.value : '').trim().replace(/[^a-zA-Z0-9_-]/g, '');
      if (!codeClean) {
        e.preventDefault();
        alert('Please choose a valid Creator Code (letters, numbers, hyphens only).');
        code.focus();
        return false;
      }

      submitRegBtn.disabled = true;
      submitRegBtn.innerHTML = `<span>Creating your creator account & dashboard...</span>`;

      // Compile clean single-string note for native Shopify customer note
      const fullNoteInput = document.getElementById('InfReg-full-note');
      const phoneVal = phone ? phone.value.trim() : '';
      const socialVal = social ? social.value.trim() : '';
      const parentClean = parentRef ? parentRef.value.trim().replace(/[^a-zA-Z0-9_-]/g, '') : '';

      if (fullNoteInput) {
        fullNoteInput.value = `account_type: influencer | code: ${codeClean} | parent: ${parentClean} | phone: ${phoneVal} | social: ${socialVal}`;
      }

      // Save pending code to localStorage so upon redirect we know this user is registered
      localStorage.setItem('gomi_influencer_code', codeClean);
      if (parentClean) {
        localStorage.setItem('gomi_sub_ref', parentClean);
      }

      // Asynchronously ping backend worker to register intent and record parent-sub relationship
      const payload = {
        email: email ? email.value.trim() : '',
        firstName: firstName ? firstName.value.trim() : '',
        lastName: lastName ? lastName.value.trim() : '',
        phone: phoneVal,
        socialHandle: socialVal,
        influencerCode: codeClean,
        parentCode: parentClean
      };

      try {
        fetch(`${BACKEND_URL}/api/register-influencer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(err => console.warn('[Influencer Reg] Backend sync warning:', err));
      } catch(err) {
        console.warn('[Influencer Reg] Sync exception:', err);
      }

      // Form proceeds to submit natively to Shopify /account (create_customer)
      return true;
    });
  }

  /* ==========================================================================
     4b. BACKGROUND VERIFICATION & SYNC FOR LOGGED-IN CREATORS
     ========================================================================== */
  if (customerEmail && (influencerCode || localStorage.getItem('gomi_influencer_code'))) {
    const activeCode = influencerCode || localStorage.getItem('gomi_influencer_code') || '';
    const activeParent = localStorage.getItem('gomi_sub_ref') || '';
    if (activeCode) {
      fetch(`${BACKEND_URL}/api/register-influencer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: customerEmail,
          customerId: customerId,
          influencerCode: activeCode,
          parentCode: activeParent
        }),
        keepalive: true
      }).catch(err => console.warn('[Background Sync] Notice:', err));
    }
  }

  /* ==========================================================================
     5. 1-CLICK ACTIVATION FOR LOGGED-IN REGULAR CUSTOMERS
     ========================================================================== */
  const activateForm = document.getElementById('InfActivateForm');
  const activateBtn = document.getElementById('inf-btn-activate');

  if (activateForm && activateBtn) {
    activateForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const codeInput = document.getElementById('InfAct-code');
      const socialInput = document.getElementById('InfAct-social');
      const phoneInput = document.getElementById('InfAct-phone');
      const parentInput = document.getElementById('InfAct-parent-ref');

      const codeVal = (codeInput ? codeInput.value : '').trim().replace(/[^a-zA-Z0-9_-]/g, '');
      if (!codeVal) {
        alert('Please enter a valid Creator Code.');
        return;
      }

      activateBtn.disabled = true;
      activateBtn.textContent = 'Activating Creator Status...';

      const payload = {
        email: customerEmail,
        customerId: customerId,
        influencerCode: codeVal,
        socialHandle: socialInput ? socialInput.value.trim() : '',
        phone: phoneInput ? phoneInput.value.trim() : '',
        parentCode: parentInput ? parentInput.value.trim() : ''
      };

      try {
        const res = await fetch(`${BACKEND_URL}/api/register-influencer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const data = await res.json();
        if (data.success || res.ok) {
          localStorage.setItem('gomi_influencer_code', codeVal);
          alert('🎉 Congratulations! Your Creator Account is now active. Refreshing your dashboard...');
          window.location.reload();
        } else {
          alert('Could not activate at this moment: ' + (data.error || 'Please try again.'));
          activateBtn.disabled = false;
          activateBtn.textContent = 'Activate Creator Dashboard Now ✨';
        }
      } catch (err) {
        console.error('[Influencer Activate] Error:', err);
        // Fallback: save to localStorage and reload
        localStorage.setItem('gomi_influencer_code', codeVal);
        alert('Creator profile updated! Loading your dashboard...');
        window.location.reload();
      }
    });
  }

  /* ==========================================================================
     6. SUB-INFLUENCER SQUAD INVITE LINK COPY
     ========================================================================== */
  const subCopyBtn = document.getElementById('inf-sub-copy-btn');
  const subInviteInput = document.getElementById('inf-sub-invite-input');

  if (subInviteInput && influencerCode) {
    subInviteInput.value = `${shopOrigin}/pages/influencer-dashboard?sub_ref=${encodeURIComponent(influencerCode)}`;
  }

  if (subCopyBtn && subInviteInput) {
    subCopyBtn.addEventListener('click', function() {
      copyToClipboard(subInviteInput.value, subCopyBtn, 'Squad Link Copied! 🚀');
    });
  }

  const masterLinkInput = document.getElementById('inf-master-link-input');
  if (masterLinkInput && influencerCode) {
    masterLinkInput.value = `${shopOrigin}/?ref=${encodeURIComponent(influencerCode)}`;
  }

  /* ==========================================================================
     7. SUB-INFLUENCER NETWORK & SQUAD DATA ENGINE
     ========================================================================== */
  const subListContainer = document.getElementById('inf-sub-creators-list');
  const subSearchInput = document.getElementById('inf-sub-search');
  const netCountCreators = document.getElementById('net-count-creators');
  const netCountOrders = document.getElementById('net-count-orders');
  const netTotalSales = document.getElementById('net-total-sales');
  const netTotalOverride = document.getElementById('net-total-override');

  let subInfluencersData = [];

  if (subListContainer && influencerCode) {
    loadSubInfluencerNetwork(influencerCode);
  }

  async function loadSubInfluencerNetwork(code) {
    // 1. Immediately render cached data from embedded metafield (0ms load time)
    subInfluencersData = getFallbackSubData();
    if (subInfluencersData && subInfluencersData.length > 0) {
      renderSubNetwork(subInfluencersData);
    }

    // 2. Fetch fresh live data from Cloudflare Worker
    try {
      const res = await fetch(`${BACKEND_URL}/api/influencer/sub-network?code=${encodeURIComponent(code)}`);
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data.subInfluencers)) {
          subInfluencersData = data.subInfluencers;
          renderSubNetwork(subInfluencersData);
          return;
        }
      }
    } catch (e) {
      console.warn('[Sub-Network] Live worker fetch notice, using embedded data:', e);
    }

    // 3. Fallback: if no embedded or live data, render empty state so spinner does not hang
    if (!subInfluencersData || subInfluencersData.length === 0) {
      renderSubNetwork([]);
    }
  }

  function getFallbackSubData() {
    try {
      const metaEl = document.getElementById('gomi-sub-network-meta');
      if (metaEl && metaEl.textContent) {
        const text = metaEl.textContent.trim();
        if (text && text !== 'null' && text !== '""') {
          let parsed = JSON.parse(text);
          if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
          }
          if (Array.isArray(parsed)) return parsed;
        }
      }
    } catch(e) {
      console.warn('[Sub-Network] Metafield JSON parse error:', e);
    }
    return [];
  }

  function renderSubNetwork(creators) {
    if (!subListContainer) return;

    // Compute Summary Stats
    const totalCreators = creators.length;
    let totalOrders = 0;
    let totalSales = 0;
    let totalOverride = 0;

    creators.forEach(c => {
      totalOrders += parseInt(c.totalOrders || c.ordersCount || c.total_orders || 0, 10);
      totalSales += parseFloat(c.totalSales || c.total_sales || 0);
      totalOverride += parseFloat(c.overrideEarned || c.parent_earnings || 0);
    });

    if (netCountCreators) netCountCreators.textContent = totalCreators;
    if (netCountOrders) netCountOrders.textContent = totalOrders;
    if (netTotalSales) netTotalSales.textContent = `${totalSales.toFixed(2)} AED`;
    if (netTotalOverride) netTotalOverride.textContent = `${totalOverride.toFixed(2)} AED`;

    if (creators.length === 0) {
      const inviteUrl = `${shopOrigin}/pages/influencer-dashboard?sub_ref=${encodeURIComponent(influencerCode)}`;
      subListContainer.innerHTML = `
        <div class="inf-sub-empty-state">
          <div style="font-size: 40px; margin-bottom: 12px;">👥</div>
          <h3 style="margin: 0 0 8px; font-size: 18px;">No Sub-Influencers in Your Squad Yet</h3>
          <p style="color: #6b7280; font-size: 14px; max-width: 500px; margin: 0 auto 20px;">
            Share your exclusive Squad Invite Link with fellow creators. When they register and sell products, you will see their sales volume and product breakdown right here!
          </p>
          <button type="button" class="inf-btn inf-btn-dark" onclick="document.getElementById('inf-sub-copy-btn')?.click()">
            Copy Squad Invite Link 🚀
          </button>
        </div>
      `;
      return;
    }

    subListContainer.innerHTML = `
      <div class="inf-sub-table-header">
        <div>Sub-Creator Profile</div>
        <div>Joined Date</div>
        <div>Orders</div>
        <div>Sales Volume</div>
        <div>Your Override</div>
        <div style="text-align: right;">Action</div>
      </div>
      ${creators.map((c, idx) => {
        const name = c.name || c.firstName || 'Creator';
        const code = c.code || c.influencerCode || 'creator';
        const social = c.social || c.socialHandle || '@creator';
        const date = c.joinedAt || c.joined_at || 'Recently';
        const orders = c.totalOrders || c.ordersCount || c.total_orders || 0;
        const sales = parseFloat(c.totalSales || c.total_sales || 0).toFixed(2);
        const override = parseFloat(c.overrideEarned || c.parent_earnings || (sales * 0.03)).toFixed(2);

        return `
          <div class="inf-sub-row" data-index="${idx}">
            <div class="inf-sub-cell-profile">
              <div class="inf-sub-avatar">${escapeHtml(name.charAt(0).toUpperCase())}</div>
              <div>
                <strong>${escapeHtml(name)}</strong>
                <span>@${escapeHtml(code)} &bull; ${escapeHtml(social)}</span>
              </div>
            </div>
            <div class="inf-sub-cell" data-label="Joined:">${escapeHtml(date)}</div>
            <div class="inf-sub-cell" data-label="Orders:"><strong>${orders}</strong> orders</div>
            <div class="inf-sub-cell" data-label="Sales Volume:"><strong style="color:#111;">${sales} AED</strong></div>
            <div class="inf-sub-cell" data-label="Your Override:"><strong style="color:#10b981;">+${override} AED</strong></div>
            <div class="inf-sub-cell" style="text-align: right;">
              <button type="button" class="inf-btn-view-products" data-index="${idx}">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
                <span>View Sold Products</span>
              </button>
            </div>
          </div>
        `;
      }).join('')}
    `;

    // Attach listeners to View Products Sold buttons
    subListContainer.querySelectorAll('.inf-btn-view-products').forEach(btn => {
      btn.addEventListener('click', function() {
        const idx = parseInt(btn.dataset.index, 10);
        openProductsSoldModal(creators[idx]);
      });
    });
  }

  // Search filter for sub-creators
  if (subSearchInput) {
    subSearchInput.addEventListener('input', function(e) {
      const term = e.target.value.toLowerCase().trim();
      if (!term) {
        renderSubNetwork(subInfluencersData);
        return;
      }
      const filtered = subInfluencersData.filter(c => {
        const name = (c.name || '').toLowerCase();
        const code = (c.code || c.influencerCode || '').toLowerCase();
        const social = (c.social || c.socialHandle || '').toLowerCase();
        return name.includes(term) || code.includes(term) || social.includes(term);
      });
      renderSubNetwork(filtered);
    });
  }

  /* ==========================================================================
     8. MODAL: SUB-INFLUENCER PRODUCTS SOLD BREAKDOWN
     ========================================================================== */
  const prodModal = document.getElementById('inf-products-sold-modal');
  const prodModalClose = document.getElementById('inf-sub-prod-close');
  const prodModalBackdrop = document.getElementById('inf-sub-prod-backdrop');
  const modalSubName = document.getElementById('inf-modal-sub-name');
  const modalSubKpis = document.getElementById('inf-modal-sub-kpis');
  const modalProdTableWrap = document.getElementById('inf-modal-prod-table-wrap');
  const modalProdSearch = document.getElementById('inf-modal-prod-search');

  let currentModalProducts = [];

  function openProductsSoldModal(creator) {
    if (!prodModal || !creator) return;

    const name = creator.name || creator.firstName || 'Creator';
    const code = creator.code || creator.influencerCode || '';
    const sales = parseFloat(creator.totalSales || creator.total_sales || 0).toFixed(2);
    const override = parseFloat(creator.overrideEarned || creator.parent_earnings || (sales * 0.03)).toFixed(2);

    if (modalSubName) {
      modalSubName.textContent = `Products Sold by ${name} (@${code})`;
    }

    if (modalSubKpis) {
      modalSubKpis.innerHTML = `
        <div class="inf-modal-kpi">
          <span>Total Sales Volume</span>
          <strong>${sales} AED</strong>
        </div>
        <div class="inf-modal-kpi highlight">
          <span>Your Override Commission</span>
          <strong>${override} AED</strong>
        </div>
      `;
    }

    currentModalProducts = creator.productsSold || creator.products_sold || [];
    renderModalProductsTable(currentModalProducts);

    prodModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function renderModalProductsTable(products) {
    if (!modalProdTableWrap) return;

    if (!products || products.length === 0) {
      modalProdTableWrap.innerHTML = `
        <div style="text-align: center; padding: 40px 10px; color: #6b7280; font-size: 13.5px;">
          <p>This sub-influencer hasn't completed any tracked product sales yet.</p>
        </div>
      `;
      return;
    }

    modalProdTableWrap.innerHTML = `
      <table class="inf-modal-table">
        <thead>
          <tr>
            <th>Product Name</th>
            <th style="text-align: center;">Qty Sold</th>
            <th style="text-align: right;">Sales (AED)</th>
            <th style="text-align: right;">Your Override</th>
          </tr>
        </thead>
        <tbody>
          ${products.map(p => {
            const title = p.title || p.name || 'Product';
            const qty = p.quantity || p.qty || 1;
            const itemSales = parseFloat(p.sales || p.totalPrice || 0).toFixed(2);
            const itemOverride = parseFloat(p.parentCommission || p.override || (itemSales * 0.03)).toFixed(2);
            const image = p.image || 'https://cdn.shopify.com/s/files/1/0890/6548/8660/files/prod4.jpg';

            return `
              <tr>
                <td>
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" style="width: 36px; height: 36px; object-fit: cover; border-radius: 4px; border: 1px solid #eee;">
                    <span style="font-weight: 600; color: #111;">${escapeHtml(title)}</span>
                  </div>
                </td>
                <td style="text-align: center;"><span class="inf-qty-badge">${qty}</span></td>
                <td style="text-align: right; font-weight: 600;">${itemSales} AED</td>
                <td style="text-align: right; font-weight: 700; color: #10b981;">+${itemOverride} AED</td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    `;
  }

  if (modalProdSearch) {
    modalProdSearch.addEventListener('input', function(e) {
      const term = e.target.value.toLowerCase().trim();
      if (!term) {
        renderModalProductsTable(currentModalProducts);
        return;
      }
      const filtered = currentModalProducts.filter(p => {
        return (p.title || p.name || '').toLowerCase().includes(term);
      });
      renderModalProductsTable(filtered);
    });
  }

  function closeProductsSoldModal() {
    if (prodModal) {
      prodModal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (prodModalClose) prodModalClose.addEventListener('click', closeProductsSoldModal);
  if (prodModalBackdrop) prodModalBackdrop.addEventListener('click', closeProductsSoldModal);

  /* ==========================================================================
     9. MASTER REFERRAL LINK COPY & SHARING
     ========================================================================== */
  const masterCopyBtn = document.getElementById('inf-master-copy-btn');
  if (masterCopyBtn && masterLinkInput) {
    masterCopyBtn.addEventListener('click', function() {
      copyToClipboard(masterLinkInput.value, masterCopyBtn, 'Copied! ✨');
    });
  }

  /* ==========================================================================
     10. PRODUCT SPECIFIC CATALOG & SHARING
     ========================================================================== */
  const productGrid = document.getElementById('inf-product-grid');
  const searchInput = document.getElementById('inf-product-search');
  let allProducts = [];

  if (productGrid) {
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootPath + 'products.json?limit=250')
      .then(response => {
        if (!response.ok) throw new Error('Network error loading products');
        return response.json();
      })
      .then(data => {
        allProducts = data.products || [];
        renderProducts(allProducts);
      })
      .catch(error => {
        console.error('[Influencer Dashboard] Error loading products:', error);
        productGrid.innerHTML = `
          <div class="inf-empty-results">
            <p>Could not load products at this moment. Please refresh the page.</p>
          </div>
        `;
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      const term = e.target.value.toLowerCase().trim();
      if (!term) {
        renderProducts(allProducts);
        return;
      }
      const filtered = allProducts.filter(p => {
        const titleMatch = (p.title || '').toLowerCase().includes(term);
        const vendorMatch = (p.vendor || '').toLowerCase().includes(term);
        const handleMatch = (p.handle || '').toLowerCase().includes(term);
        return titleMatch || vendorMatch || handleMatch;
      });
      renderProducts(filtered);
    });
  }

  function renderProducts(products) {
    if (!productGrid) return;

    if (!products || products.length === 0) {
      productGrid.innerHTML = `
        <div class="inf-empty-results">
          <p>No products found matching your search.</p>
        </div>
      `;
      return;
    }

    productGrid.innerHTML = products.map(product => {
      const featuredImage = product.images && product.images.length > 0 
        ? product.images[0].src 
        : 'https://cdn.shopify.com/s/files/1/0890/6548/8660/files/prod4.jpg';
      
      const price = product.variants && product.variants.length > 0 
        ? `${parseFloat(product.variants[0].price).toFixed(2)} AED` 
        : '';

      const productAffiliateUrl = `${shopOrigin}/products/${product.handle}?ref=${encodeURIComponent(influencerCode)}`;
      const waText = encodeURIComponent(`Check out ${product.title} on GomiMall: ${productAffiliateUrl}`);
      const waUrl = `https://wa.me/?text=${waText}`;

      return `
        <div class="inf-product-card" data-handle="${escapeHtml(product.handle)}">
          <div class="inf-product-image-wrap">
            <img src="${escapeHtml(featuredImage)}" alt="${escapeHtml(product.title)}" loading="lazy">
          </div>
          <div class="inf-product-content">
            <span class="inf-product-vendor">${escapeHtml(product.vendor || 'GomiMall')}</span>
            <h3 class="inf-product-title">${escapeHtml(product.title)}</h3>
            <div class="inf-product-price">${escapeHtml(price)}</div>
            
            <div class="inf-product-link-row">
              <div class="inf-product-link-preview" title="${escapeHtml(productAffiliateUrl)}">
                ${escapeHtml(productAffiliateUrl)}
              </div>
              <div class="inf-product-action-btns">
                <button class="inf-btn-copy-prod" data-url="${escapeHtml(productAffiliateUrl)}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                  <span>Copy Link</span>
                </button>
                <a href="${waUrl}" target="_blank" rel="noopener noreferrer" class="inf-btn-wa-prod" title="Share on WhatsApp">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    productGrid.querySelectorAll('.inf-btn-copy-prod').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const url = btn.dataset.url;
        copyToClipboard(url, btn, 'Copied! ✨');
      });
    });
  }

  /* ==========================================================================
     11. CASHOUT MODAL CONTROLS
     ========================================================================== */
  const redeemBtn = document.getElementById('inf-redeem-btn');
  const cashoutModal = document.getElementById('creator-cashout-modal');
  const cashoutClose = document.getElementById('inf-cashout-close');
  const cashoutBackdrop = document.getElementById('inf-cashout-backdrop');
  const cashoutSelect = document.getElementById('cashout-method-select');
  const cashoutBankFields = document.getElementById('cashout-bank-fields');

  if (redeemBtn && cashoutModal) {
    redeemBtn.addEventListener('click', function() {
      cashoutModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCashoutModal() {
    if (cashoutModal) {
      cashoutModal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (cashoutClose) cashoutClose.addEventListener('click', closeCashoutModal);
  if (cashoutBackdrop) cashoutBackdrop.addEventListener('click', closeCashoutModal);

  if (cashoutSelect && cashoutBankFields) {
    cashoutSelect.addEventListener('change', function() {
      cashoutBankFields.style.display = this.value.includes('Bank') ? 'block' : 'none';
    });
  }

  /* ==========================================================================
     12. CUSTOM URL GENERATOR
     ========================================================================== */
  const customUrlInput = document.getElementById('inf-custom-url-input');
  const customUrlBtn = document.getElementById('inf-custom-url-btn');
  const customUrlResult = document.getElementById('inf-custom-url-result');
  const customUrlOutput = document.getElementById('inf-custom-url-output');
  const customCopyBtn = document.getElementById('inf-custom-copy-btn');

  if (customUrlBtn && customUrlInput && customUrlOutput && customUrlResult) {
    customUrlBtn.addEventListener('click', function() {
      let rawUrl = customUrlInput.value.trim();
      if (!rawUrl) return;
      try {
        if (!rawUrl.startsWith('http://') && !rawUrl.startsWith('https://') && !rawUrl.startsWith('/')) {
          rawUrl = window.location.origin + '/' + rawUrl;
        } else if (rawUrl.startsWith('/')) {
          rawUrl = window.location.origin + rawUrl;
        }
        const parsed = new URL(rawUrl);
        parsed.searchParams.set('ref', influencerCode);
        customUrlOutput.value = parsed.toString();
        customUrlResult.style.display = 'flex';
        copyToClipboard(parsed.toString(), customCopyBtn, 'Copied! ✨');
      } catch(e) {
        const separator = rawUrl.includes('?') ? '&' : '?';
        const finalUrl = rawUrl + separator + 'ref=' + encodeURIComponent(influencerCode);
        customUrlOutput.value = finalUrl;
        customUrlResult.style.display = 'flex';
      }
    });

    if (customCopyBtn) {
      customCopyBtn.addEventListener('click', function() {
        copyToClipboard(customUrlOutput.value, customCopyBtn, 'Copied! ✨');
      });
    }
  }

  /* ==========================================================================
     13. CLIPBOARD & UTILITY FUNCTIONS
     ========================================================================== */
  function copyToClipboard(text, buttonElement, successMsg) {
    if (!navigator.clipboard) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        triggerCopyFeedback(buttonElement, successMsg);
      } catch (err) {
        console.error('Copy fallback failed:', err);
      }
      document.body.removeChild(textarea);
      return;
    }

    navigator.clipboard.writeText(text)
      .then(() => {
        triggerCopyFeedback(buttonElement, successMsg);
      })
      .catch(err => {
        console.error('Clipboard error:', err);
      });
  }

  function triggerCopyFeedback(btn, message) {
    if (!btn) return;
    const originalContent = btn.innerHTML;
    btn.classList.add('inf-btn-copied');
    btn.innerHTML = `<span>${message}</span>`;
    setTimeout(() => {
      btn.classList.remove('inf-btn-copied');
      btn.innerHTML = originalContent;
    }, 2000);
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Handle ESC key to close all modals
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCashoutModal();
      closeProductsSoldModal();
    }
  });
});
